/**
 * @generated SignedSource<<e673d5b3e29b680e840d01f4e93cf5ad>>
 * @relayHash 8fc94d7f228f0fbee25d0269ff0be837
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 34e4bf51a4670ec086536c73344f42585dbf16a8818e18654df008989303bcd2

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraContainerNavigationQueryInput = {
  projectKeyQuery?: JiraContainerNavigationByProjectKeyQueryInput | null;
  scopeId?: string | null;
};
export type JiraContainerNavigationByProjectKeyQueryInput = {
  cloudId: string;
  projectKey: string;
};
export type HorizontalNavJiraInnerQuery$variables = {
  boardId: string;
  cloudId: string;
  containerNavigationInput: JiraContainerNavigationQueryInput;
  first: number;
  projectIdOrKey: string;
  skipMostRecentlyViewedBoard: boolean;
  withBoard: boolean;
  withProject: boolean;
};
export type HorizontalNavJiraInnerQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JiraHorizontalNavigationContent_query">;
};
export type HorizontalNavJiraInnerQuery = {
  response: HorizontalNavJiraInnerQuery$data;
  variables: HorizontalNavJiraInnerQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplatesuxfgrelayprovider": isJiraCustomTemplatesUxEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider": isJiraExternalGuestsSpaceFlagEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSea3716JiraCreateViewWithRovoRelayprovider": isJiraCreateViewWithRovoEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgenticSummaryViewRelayProvider": isJiraAgenticSummaryViewEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcAutonomousAgentsInSpaceRelayProvider": includeAddAgents_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcAutonomousAgentsInSpaceRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgenticSummaryViewRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSea3716JiraCreateViewWithRovoRelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplatesuxfgrelayprovider: {
    readonly get: () => boolean;
  };
});

import includeAddAgents_provider from '@jira/platform__graphql-relay-provider/src/AutonomousAgentsInSpaceRelayProvider';
import isJiraAgenticSummaryViewEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraAgenticSummaryViewRelayProvider';
import isJiraExternalGuestsSpaceFlagEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraExternalGuestsSpaceFlagRelayprovider';
import isJiraCreateViewWithRovoEnabled_provider from '@jira/platform__graphql-relay-provider/src/Sea3716JiraCreateViewWithRovoRelayprovider';
import isJiraCustomTemplatesUxEnabled_provider from '@jira/platform__graphql-relay-provider/src/jira-custom-templates-ux-fg.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerNavigationInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIdOrKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipMostRecentlyViewedBoard"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withBoard"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withProject"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "url"
},
v11 = {
  "kind": "ScalarField",
  "name": "label"
},
v12 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v13 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v14 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v15 = [
  {
    "kind": "ScalarField",
    "name": "message"
  },
  {
    "kind": "LinkedField",
    "name": "extensions",
    "plural": true,
    "selections": [
      (v8/*: any*/),
      {
        "kind": "ScalarField",
        "name": "statusCode"
      }
    ]
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "canEdit"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v18 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v19 = [
  (v18/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "name": "name"
},
v21 = {
  "kind": "ScalarField",
  "name": "boardId"
},
v22 = {
  "kind": "ScalarField",
  "name": "boardType"
},
v23 = {
  "concreteType": "JiraFavouriteValue",
  "kind": "LinkedField",
  "name": "favouriteValue",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    },
    (v9/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HorizontalNavJiraInnerQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "JiraHorizontalNavigationContent_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSea3716JiraCreateViewWithRovoRelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgenticSummaryViewRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcAutonomousAgentsInSpaceRelayProvider"
      }
    ],
    "kind": "Operation",
    "name": "HorizontalNavJiraInnerQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "containerNavigationInput"
              }
            ],
            "kind": "LinkedField",
            "name": "containerNavigation",
            "plural": false,
            "selections": [
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraContainerNavigationResult"
              },
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "scopeId"
                  },
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "first"
                      }
                    ],
                    "concreteType": "JiraNavigationItemConnection",
                    "kind": "LinkedField",
                    "name": "navigationItems",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraNavigationItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "isDefault"
                              },
                              (v10/*: any*/),
                              (v9/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "typeKey"
                              },
                              (v11/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isJiraNavigationItem"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRename"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemove"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canSetAsDefault"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "scopedUrl",
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "JiraSoftwareBuiltInNavigationItem"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "appId"
                                  },
                                  {
                                    "concreteType": "JiraAppSection",
                                    "kind": "LinkedField",
                                    "name": "sections",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraAppNavigationItemNestedLink",
                                        "kind": "LinkedField",
                                        "name": "links",
                                        "plural": true,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v11/*: any*/),
                                          (v12/*: any*/),
                                          (v13/*: any*/)
                                        ]
                                      },
                                      (v11/*: any*/)
                                    ]
                                  },
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "envLabel"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v14/*: any*/)
                                    ],
                                    "type": "JiraNavigationItem",
                                    "abstractKey": "__isJiraNavigationItem"
                                  }
                                ],
                                "type": "JiraAppNavigationItem"
                              },
                              (v14/*: any*/)
                            ]
                          },
                          (v8/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": (v15/*: any*/)
                      }
                    ]
                  },
                  (v16/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "scopeUrl"
                  }
                ],
                "type": "JiraContainerNavigation"
              },
              {
                "kind": "InlineFragment",
                "selections": (v15/*: any*/),
                "type": "QueryError"
              },
              (v17/*: any*/)
            ]
          },
          {
            "args": (v19/*: any*/),
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "currentUserSeatEdition"
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgenticSummaryViewRelayProvider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v19/*: any*/),
                "concreteType": "JiraRovoEnablementStatus",
                "kind": "LinkedField",
                "name": "rovoEnablementStatus",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "rovoAiFeaturesEnabledJiraProducts"
                  }
                ]
              }
            ]
          },
          {
            "condition": "withBoard",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "boardId"
                  }
                ],
                "kind": "LinkedField",
                "name": "jiraBoard",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v20/*: any*/),
                      (v9/*: any*/),
                      (v21/*: any*/),
                      (v16/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v14/*: any*/)
                    ],
                    "type": "JiraBoard"
                  },
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "withProject",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v18/*: any*/),
              {
                "kind": "Variable",
                "name": "idOrKey",
                "variableName": "projectIdOrKey"
              }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "large"
                  }
                ]
              },
              {
                "alias": "canEditProjectConfig",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canPerform"
                  }
                ],
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
              },
              (v9/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "projectStyle"
              },
              (v20/*: any*/),
              {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "softwareBoardCount"
              },
              {
                "condition": "skipMostRecentlyViewedBoard",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "mostRecentlyViewedBoard",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v21/*: any*/),
                          (v20/*: any*/),
                          (v16/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v14/*: any*/)
                        ],
                        "type": "JiraBoard"
                      },
                      (v17/*: any*/)
                    ]
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isLiveTemplate"
                  }
                ]
              },
              (v14/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "34e4bf51a4670ec086536c73344f42585dbf16a8818e18654df008989303bcd2",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplatesuxfgrelayprovider": isJiraCustomTemplatesUxEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider": isJiraExternalGuestsSpaceFlagEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSea3716JiraCreateViewWithRovoRelayprovider": isJiraCreateViewWithRovoEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgenticSummaryViewRelayProvider": isJiraAgenticSummaryViewEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcAutonomousAgentsInSpaceRelayProvider": includeAddAgents_provider
    }
  }
};
})();

(node as any).hash = "2957badc2547b41d4e2a670b8b1400f4";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
